import React, { useState } from 'react'
import { ReportHeading } from '../../UserProfile/styles'
import { BackArrowFeed } from '../../../utils/icons'
import { ArticleContainer } from '../../Article/styles'
import { VideoContainerNew } from '../../MainEvents/OnDemandVideoDetailsPage/styles'
import ReactPlayer from 'react-player'
import SkeletonLoder from '../../common/skeletonLoder'
import { useLocation, useHistory } from 'react-router-dom'
import AudioPlayer from '../../common/AudioPlayer/AudioPlayer'
import { ImageUrl } from '../../../utils/constants'
import FeelingModal from './FeelingModal'


function AudioVideoDetailsPage() {
  const location = useLocation();
  const history = useHistory();
  const [loadingVideo, setLoadingVideo] = useState(true); 
  const [openFeelingModal, setOpenFeelingModal] = useState(false);

  const handleMediaComplete = () => {
    if (isToday && !isCompleted) {
      setOpenFeelingModal(true);
    }
  };

  const { media_link, media_type, media_thumbnail, taskId, challengeId, isToday, isCompleted, heading, showListenText } =
    location.state || {};





  return (
    <div style={{ maxWidth: "1246px", padding: "24px 0px 40px 0px", margin: "auto", width: "100%" }}>
      <ReportHeading>
        <div className="left-section">
          <div className="icon" onClick={() => history.goBack()}>
            {BackArrowFeed('#DA6C74')}
          </div>
          <div className="title">{ heading ? heading :"Podcast"}</div>
        </div>
      </ReportHeading>

      <ArticleContainer>
        {media_type === "mp4" && (<VideoContainerNew
          margin={'15px'}
          loadingVideo={loadingVideo}
          style={{ float: 'unset' }}
          height={'679px'}
        >
          {media_link ? (
            <ReactPlayer
              className="react-player"
              url={media_link}
              controls
              width="100%"
              height="100%"
              onReady={() => setLoadingVideo(false)}
              onEnded={handleMediaComplete}  
            />
          ) : (
            <div>No media available</div>
          )}

          {loadingVideo && (
            <SkeletonLoder width={"640px"} height={"470px"} />
          )}
        </VideoContainerNew>
        
        )}
        {/* ✅ AUDIO */}
        {media_type === "mp3" && (
          <>
            {/* Thumbnail (optional) */}
            {media_thumbnail && (
              <img
                src={ImageUrl + "/" + media_thumbnail}
                alt="audio thumbnail"
                style={{
                  width: "100%",
                  height: "400px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  margin: "20px 0"
                }}
              />
            )}
      
            <AudioPlayer
              src={media_link?.startsWith("http") ? media_link : ImageUrl + "/" + media_link}
              title="audio"
              margin={"20px 0px"}
              onComplete={handleMediaComplete} 
              showListenText={showListenText}
            />
          </>
        )}
      
        {!media_link && <div>No media available</div>}

      </ArticleContainer>
      {openFeelingModal && <FeelingModal  completedStatus={true}   taskId={taskId}    /*setActiveTab={setActiveTab}*/ showModal={openFeelingModal} onHide={() => setOpenFeelingModal(false)}  challengeId={challengeId} />}
      
    </div>
  );
}

export default AudioVideoDetailsPage
